import React from 'react';
import { getCurrency } from '../helpers/internationalization';


  class Receipt extends React.PureComponent {
    render() {
      if (this.props.hidden) {
        return <React.Fragment />;
      }
      return (<div className="receipt">
        <div className="receipt-breakdown">
        <div className="receipt-breakdown--header">
          <p>Reciept for</p>
          <b className="receipt-client">{this.props.clientName}</b>
        </div>
        <ul className="receipt-breakdown--list">  
            <BreakDownEntry key={1} index={1} details={{
                "text" : "Amount:",
                "main" : this.props.amount,
                "icon" : "usd"
            }} />
            <BreakDownEntry key={2} index={2} details={{
                "text" : "Issuer:",
                "main" : this.props.merchantName,
                "icon" : "star-empty"
            }} />
        </ul>
      </div>
      <Overview product='Payment Receipt'
                merchant={this.props.merchantName}
                merchantEmail={this.props.merchantEmail}
                name={this.props.clientName}
                value={`${this.props.amount} ${getCurrency(this.props.country)}`}
                receiptNo={this.props.receiptNo}
                createdAt={this.props.createdAt} />
      </div>)
    }
  }
  
  
  class BreakDownEntry extends React.Component {
    render() {
      const { details } = this.props;
      return <li>
            <span class={`glyphicon glyphicon-${details.icon}`}>
            </span>
            <div className="list-content">
                <p>{details.text}
                  <span className="list-bold">{details.main}</span>  
                </p>
            </div>
       </li>
    }
  }
  
  class Overview extends React.Component {
    render() {
      return <div className="receipt-overview">
        <OverviewHeader logo={'/img/logo.png'} createdAt={this.props.createdAt} />
        <OverviewBody {...this.props} />
        <OverviewFooter {...this.props} />
      </div>
    }
  }
  
  class OverviewHeader extends React.Component {
    render() {
      return <div className="overview-header">
        <img className="receipt-logo" src={this.props.logo}/>
        <div className="receipt-timestamp">
          <span>{this.props.createdAt}</span>
        </div>
        
        <hr />
      </div>
    }
  }
  
  class PurchaseOverview extends React.Component {
    render() {
      return <div className="purchase-overview"> 
        <h3>{this.props.product}</h3>
      </div>
    }
  }
  
  class OverviewBody extends React.Component {
    render() {
      return <div className="overview-body">
        <PurchaseOverview {...this.props} />
        <div className="user-info">
          <p className="user-info-name"> Hello {this.props.name},</p>
          <p className="user-info-text"> You sent a payment of <span>${this.props.value}</span> to {this.props.merchant} (<a href={`mailto: ${this.props.merchantEmail}`}>{this.props.merchantEmail}</a>).</p>
          <p>It may take a few moments for this transaction to appear in your account</p>
          <p>Thank you for choosing {this.props.merchant}.</p>
        </div>
      </div>
    }
  }
  
  
  class OverviewFooter extends React.Component {
    render() {
      return <footer className="overview-footer">
          <span className="site">
            Receipt Reference Number:
          </span>
          <span className="invoice-id">
            {this.props.receiptNo}
          </span>
      </footer>
    }
  }


export default Receipt;